const shopRegex = new RegExp(
  `^[a-z0-9][a-z0-9\\-]*[a-z0-9]\\.myshopify.com$`,
  'i',
);

export default function isShopDomainValid(shop: string) {
  return shopRegex.test(shop)
}
